// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import HomeNew from './components/HomeNew';
import AuthComponent from './components/LandingPage';
import FormDetails from './components/FormDetails';
import AdmitDetails from './components/AdmitDetails';
import NewForm from './components/NewForm';
import AdmitDownload from './components/AdmitDownload';
//import Profile from './components/Profile';

function App() {
  const [auth, setAuth] = useState({ user: "" });

  return (
    <Router>
      <Routes>
        <Route path="/admit-details/:applicationNumber" element={<AdmitDetails />} />
		    <Route path='/' element={<AuthComponent setAuth={setAuth} />} />
        <Route path='/downloadAdmit' element={<AdmitDownload />} />
        
        {/*
        <Route path="/form-details/:applicationNumber" element={<FormDetails />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/newForm' element={<NewForm />} />
        <Route path='/home' element={<HomeNew />} />
        */}
        
      </Routes>
    </Router>
  );
}

export default App;
